(function analitycs(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.FullImageViewer = global.NewHomeSource.FullImageViewer || {};

  if (!global.NewHomeSource.AnalitycsHelper ||
    !global.NewHomeSource.FullImageViewer.Config) {
    return;
  }

  const googleAnalyticsId = global.NewHomeSource.AnalitycsHelper.getGoogleAnalitycsIdentifier() + '.send';
  const eventsCategory = 'Gallery Detail Pages';
  const eventLabel = 'event';
  const previousAnalitycs = global.NewHomeSource.FullImageViewer.Analitycs;
  const eventToAttach = global.NewHomeSource.FullImageViewer.Config.getClickOrTouchEvent();

  /**
  * @constructs NewHomeSource.FullImageViewer.Analitycs
  */
  function Analitycs() {
  }

  function logCloseFullImageEvent() {
    global.ga(
      googleAnalyticsId,
      eventLabel,
      eventsCategory,
      'Clicks to Close Gallery Viewer',
      'Arrow - Close'
    );
  }

  function logSaveEvent() {
    global.ga(googleAnalyticsId, eventLabel, eventsCategory, 'Favorite - FWIV Top', 'Favorite Heart Icon Clicks');
  }

  function logScheduleTourTopEvent() {
    global.ga(googleAnalyticsId, eventLabel, eventsCategory, 'FWIV - Top - Sched Virtual Tour', 'CTA - Modal Open');
  }

  function logMoreInfoEvent() {
    global.ga(googleAnalyticsId, eventLabel, eventsCategory, 'FWIV - More Info Panel Open', 'More Info Panel Opened');
  }

  function logUpThumbnailsEvent() {
    global.ga(googleAnalyticsId, eventLabel, eventsCategory, 'FWIV thumbs up-down', 'Up');
  }

  function logDownThumbnailsEvent() {
    global.ga(googleAnalyticsId, eventLabel, eventsCategory, 'FWIV thumbs up-down', 'Down');
  }

  function logSelectedThumbnailEvent() {
    global.ga(googleAnalyticsId, eventLabel, eventsCategory, 'FWIV thumbs click', 'FWIV thumb clicked');
  }

  function logBackwardFullImageEvent() {
    global.ga(googleAnalyticsId, eventLabel, eventsCategory, 'FWIV Gallery forward-back', 'Back');
  }

  function logForwardFullImageEvent() {
    global.ga(googleAnalyticsId, eventLabel, eventsCategory, 'FWIV Gallery forward-back', 'Forward');
  }

  function logCloseMoreInfoEvent() {
    global.ga(googleAnalyticsId, eventLabel, eventsCategory, 'FWIV - More Info Panel Close', 'More Info Panel Closed');
  }

  function logScheduleTourEvent() {
    global.ga(
      googleAnalyticsId,
      eventLabel,
      eventsCategory,
      'FWIV - MoreInfo - Sched Virtual Tour',
      'CTA - Modal Open'
    );
  }

  function logContactBuilderEvent() {
    global.ga(googleAnalyticsId, eventLabel, eventsCategory, 'FWIV - MoreInfo - Contact Builder', 'CTA - Modal Open');
  }

  function logAskQuestionEvent() {
    global.ga(googleAnalyticsId, eventLabel, eventsCategory, 'FWIV - MoreInfo - Ask A Question', 'CTA - Modal Open');
  }

  function logCopyLinkEvent() {
    global.ga(googleAnalyticsId, eventLabel, eventsCategory, 'FWIV - copy link', 'Copy link');
  }

  function logEmailEvent() {
    global.ga(googleAnalyticsId, eventLabel, eventsCategory, 'FWIV - email link', 'Email');
  }

  function logSaveFromMoreInfoEvent() {
    global.ga(
      googleAnalyticsId,
      eventLabel,
      eventsCategory,
      'Favorite - FWIV More Info Section',
      'Favorite Heart Icon Clicks'
    );
  }

  function logCollectionEvent(event) {
    const label = event.target.textContent + ' tab clicks';
    global.ga(googleAnalyticsId, eventLabel, eventsCategory, 'Gallery Navigation', label);
  }

  function logOpenExternalLinkEvent(event) {
    const code = event.target.closest('[data-external-link]').getAttribute('data-item-id');
    global.ga(
      googleAnalyticsId,
      eventLabel,
      eventsCategory,
      'FWIV - Open iframe in New Window',
      'FWIV open media ' + code
    );
  }

  const eventsConfiguration = {
    closeFullImage: {
      callbacks: [logCloseFullImageEvent],
      events: [eventToAttach],
      elements: '[data-full-image-viewer-role="close"]',
    },
    saveFullImage: {
      callbacks: [logSaveEvent],
      events: [eventToAttach],
      elements: '[data-component="full-image-viewer-favorites"]',
    },
    scheduleFullImage: {
      callbacks: [logScheduleTourTopEvent],
      events: [eventToAttach],
      elements: '[data-component="full-image-viewer-schedule-tour-cta"]',
    },
    moreInfoFullImage: {
      callbacks: [logMoreInfoEvent],
      events: [eventToAttach],
      elements: '[data-component="data-nav-call-to-action"], [data-more-information-btn="true"]',
    },
    upArrowFullImage: {
      callbacks: [logUpThumbnailsEvent],
      events: [eventToAttach],
      elements: '[data-full-image-viewer-role="up"]',
    },
    downArrowFullImage: {
      callbacks: [logDownThumbnailsEvent],
      events: [eventToAttach],
      elements: '[data-full-image-viewer-role="down"]',
    },
    selectedThumbFullImage: {
      callbacks: [logSelectedThumbnailEvent],
      events: [eventToAttach],
      elements: '[data-full-image-viewer-role="filmstrip"]',
    },
    leftArrowFullImage: {
      callbacks: [logBackwardFullImageEvent],
      events: [eventToAttach],
      elements: '[data-full-image-viewer-role="left"], [data-full-image-viewer-role="leftArrow"]',
    },
    rightArrowFullImage: {
      callbacks: [logForwardFullImageEvent],
      events: [eventToAttach],
      elements: '[data-full-image-viewer-role="right"], [data-full-image-viewer-role="rightArrow"]',
    },
    closeMoreInfoFullImage: {
      callbacks: [logCloseMoreInfoEvent],
      events: [eventToAttach],
      elements: '[data-close-panel-action="true"]',
    },
    scheduleTourAfterMoreInfoFullImage: {
      callbacks: [logScheduleTourEvent],
      events: [eventToAttach],
      elements: '[data-schedule-panel-actions]',
    },
    contactBuilderAfterMoreInfoFullImage: {
      callbacks: [logContactBuilderEvent],
      events: [eventToAttach],
      elements: '[data-contact-builder-panel-actions]',
    },
    askBuilderAfterMoreInfoFullImage: {
      callbacks: [logAskQuestionEvent],
      events: [eventToAttach],
      elements: '[data-ask-question-panel-actions]',
    },
    copyFullImage: {
      callbacks: [logCopyLinkEvent],
      events: [eventToAttach],
      elements: '[data-copy-link]',
    },
    emailFullImage: {
      callbacks: [logEmailEvent],
      events: [eventToAttach],
      elements: '[data-email]',
    },
    saveFromMoreInfoFullImage: {
      callbacks: [logSaveFromMoreInfoEvent],
      events: [eventToAttach],
      elements: '[data-panel-actions] [data-component="full-image-viewer-favorites"], [data-favorites-button="true"]',
    },
    collectionFullImage: {
      callbacks: [logCollectionEvent],
      events: [eventToAttach],
      elements: '[data-collection-item]',
    },
    externalLink: {
      callbacks: [logOpenExternalLinkEvent],
      events: [eventToAttach],
      elements: '[data-external-link]',
    },
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.FullImageViewer.Analitycs to the previous script.
   */
  Analitycs.noConflict = function noConflict() {
    global.NewHomeSource.FullImageViewer.Analitycs = previousAnalitycs;
    return Analitycs;
  };

  if (global.ga) {
    global.NewHomeSource.Event(eventsConfiguration);
  }
  global.NewHomeSource.FullImageViewer.Analitycs = Analitycs;
}(window));
